module.exports = __webpack_public_path__ + "img/badge.7dac90d5.svg";